module.exports = __webpack_public_path__ + "static/img/diefaPro.975acfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/diefaPro.png
// module id = sho3
// module chunks = 1